module.exports = __webpack_public_path__ + "img/bgcc.0b49f9a4.svg";